import { render } from "./pwChangeResult.vue?vue&type=template&id=7728accc&scoped=true&ts=true"
import script from "./pwChangeResult.vue?vue&type=script&lang=ts"
export * from "./pwChangeResult.vue?vue&type=script&lang=ts"

import "./pwChangeResult.vue?vue&type=style&index=0&id=7728accc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/ws-frontend-join/ws-frontend-join/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7728accc"]])

export default __exports__